var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cf-node-properties__hours-filter-breaks-add",
      class: { open: _vm.showBreakForm }
    },
    [
      _vm.showBreakForm
        ? _c(
            "div",
            { staticClass: "cf-node-properties__hours-filter-breaks-form" },
            [
              _c("div", { staticClass: "cf-node-properties__field" }, [
                _c("label", [_vm._v("Start Time")]),
                _vm._v(" "),
                _c("div", { staticClass: "cf-node-properties__input m-r-5" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.timeBreak.time,
                        expression: "timeBreak.time"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "time",
                      step: "300",
                      "aria-label": "Break Time"
                    },
                    domProps: { value: _vm.timeBreak.time },
                    on: {
                      change: _vm.setStartTime,
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.timeBreak, "time", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cf-node-properties__field" }, [
                _c("label", [_vm._v("Duration (Min)")]),
                _vm._v(" "),
                _c("div", { staticClass: "cf-node-properties__input" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.timeBreak.lengthInMin,
                        expression: "timeBreak.lengthInMin"
                      }
                    ],
                    staticClass: "form-control",
                    class: { invalid: !_vm.timeBreak.lengthInMin },
                    attrs: {
                      type: "number",
                      "aria-label": "Duration in Minutes"
                    },
                    domProps: { value: _vm.timeBreak.lengthInMin },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.timeBreak,
                          "lengthInMin",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cf-node-properties__action-buttons" },
        [
          !_vm.showBreakForm
            ? _c(
                "button",
                {
                  staticClass: "btn btn-success btn-sm",
                  attrs: { type: "button" },
                  on: { click: _vm.toggleBreakForm }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Add Break")])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showBreakForm
            ? [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success btn-sm m-r-10",
                    attrs: { type: "button" },
                    on: { click: _vm.addBreak }
                  },
                  [_vm._v("\n        Save\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger btn-sm",
                    attrs: { type: "button" },
                    on: { click: _vm.toggleBreakForm }
                  },
                  [_vm._v("\n        Cancel\n      ")]
                )
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }